import { genUUID } from "./utils";
import { Language } from "../types";
import axios from "axios";

interface StartRequestConfig {
  channel: string;
  userId: number;
  graphName: string;
  language: Language;
  voiceType: "male" | "female";
}

interface GenAgoraDataConfig {
  userId: string | number;
  channel: string;
}

export const apiGenAgoraData = async (config: GenAgoraDataConfig) => {
  // the request will be rewrite at middleware.tsx to send to $AGENT_SERVER_URL
  const url = `http://cdksta-tenag-yzpvjmyjeqex-879945066.eu-central-1.elb.amazonaws.com/token/generate`;
  const { userId, channel } = config;
  const data = {
    request_id: genUUID(),
    uid: userId,
    channel_name: channel
  };
  let resp: any = await axios.post(url, data);
  resp = (resp.data) || {};
  return resp;
};

export const apiStartService = async (config: StartRequestConfig): Promise<any> => {
  // look at app/apis/route.tsx for the server-side implementation
  const url = `http://cdksta-tenag-yzpvjmyjeqex-879945066.eu-central-1.elb.amazonaws.com/start`;
  const { channel, userId, graphName, language, voiceType } = config;
  const data = {
    request_id: genUUID(),
    channel_name: channel,
    user_uid: userId,
    graph_name: graphName,
    language,
    voice_type: voiceType
  };
  let resp: any = await axios.post(url, data);
  resp = (resp.data) || {};
  return resp;
};

export const apiStopService = async (channel: string) => {
  // the request will be rewrite at middleware.tsx to send to $AGENT_SERVER_URL
  const url = `http://cdksta-tenag-yzpvjmyjeqex-879945066.eu-central-1.elb.amazonaws.com/stop`;
  const data = {
    request_id: genUUID(),
    channel_name: channel
  };
  let resp: any = await axios.post(url, data);
  resp = (resp.data) || {};
  return resp;
};

// ping/pong 
export const apiPing = async (channel: string) => {
  // the request will be rewrite at middleware.tsx to send to $AGENT_SERVER_URL
  const url = `http://cdksta-tenag-yzpvjmyjeqex-879945066.eu-central-1.elb.amazonaws.com/ping`;
  const data = {
    request_id: genUUID(),
    channel_name: channel
  };
  try {
    let resp: any = await axios.post(url, data);
    resp = (resp.data) || {};
    return resp;
  } catch (error) {
    console.error('Ping error:', error);
    return { code: 1, msg: 'Connection error' };
  }
};

export const apiFetchGraphs = async () => {
  let resp: any = await axios.get(`http://cdksta-tenag-yzpvjmyjeqex-879945066.eu-central-1.elb.amazonaws.com/graphs`);
  return resp.data.data.map((graph: any) => ({
    id: graph.name,
    autoStart: graph.auto_start,
  }));
};
